import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lock',
  templateUrl: './lock.component.html',
  styleUrls: ['./lock.component.scss']
})
export class LockComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    document.title = 'Account Locked | Rubii - Digital Media Trading';
  }

}